import { Plus, Trash2 } from 'lucide-react'

/**
 * Lista editável de faixas de defesa em valor fixo (fluxo cavalo).
 * Controlado: recebe `faixas` e notifica mudanças via `onChange`.
 */
export default function FaixasDefesaEditor({ faixas, onChange, disabled = false }) {
  const adicionar = () => {
    const ultima = faixas[faixas.length - 1]
    onChange([
      ...faixas,
      { valor_min: ultima ? (ultima.valor_max ?? '') : 0, valor_max: '', valor_fixo: '' }
    ])
  }

  const remover = (index) => {
    onChange(faixas.filter((_, i) => i !== index))
  }

  const atualizar = (index, campo, valor) => {
    onChange(faixas.map((f, i) => i === index ? { ...f, [campo]: valor } : f))
  }

  return (
    <div className="space-y-2">
      {faixas.length === 0 && (
        <p className="text-sm text-gray-500">Nenhuma faixa cadastrada.</p>
      )}

      {faixas.map((faixa, index) => (
        <div key={index} className="grid grid-cols-1 sm:grid-cols-3 gap-2 p-3 sm:p-0 border border-gray-200 sm:border-0 rounded-lg">
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">De (R$)</label>
            <input
              type="number" step="0.01" min="0" disabled={disabled}
              value={faixa.valor_min}
              onChange={(e) => atualizar(index, 'valor_min', e.target.value)}
              className="input-rematei text-sm w-full" placeholder="0,00"
            />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Até (R$)</label>
            <input
              type="number" step="0.01" min="0" disabled={disabled}
              value={faixa.valor_max ?? ''}
              onChange={(e) => atualizar(index, 'valor_max', e.target.value)}
              className="input-rematei text-sm w-full" placeholder="Sem teto"
            />
          </div>
          <div className="flex items-end gap-2">
            <div className="flex-1">
              <label className="block text-xs font-medium text-gray-500 mb-1">Defesa fixa (R$)</label>
              <input
                type="number" step="0.01" min="0" disabled={disabled}
                value={faixa.valor_fixo}
                onChange={(e) => atualizar(index, 'valor_fixo', e.target.value)}
                className="input-rematei text-sm w-full" placeholder="500,00"
              />
            </div>
            {!disabled && (
              <button
                type="button"
                onClick={() => remover(index)}
                className="p-2 text-red-600 hover:bg-red-50 rounded flex-shrink-0"
                title="Remover faixa"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      ))}

      {!disabled && (
        <button
          type="button"
          onClick={adicionar}
          className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800 font-medium mt-1"
        >
          <Plus className="w-4 h-4" /> Adicionar faixa
        </button>
      )}
    </div>
  )
}
